import authorizationModule from "./authorizationModule"

authorizationModule.run(function (authenticationService, permissionService) {
    authenticationService.addAuthenticationCallback({
        onLogOut() {
            permissionService.getAuthorization.expire()
        }
    })
})